module.exports = __webpack_public_path__ + "media/images/front/treatment_support/setting_add_home_screen/img10-16bf4c48eb718cc051832609a40b8281.png";